module.exports = __webpack_public_path__ + "img/zu3484.295eac2d.png";